export default __webpack_public_path__ + "e31eb4357d8d2cd0214aef20823743cb.png";